var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"inline-alert-footer-link",attrs:{"href":_vm.href,"rel":"noopener noreferrer","target":"_blank"}},[_vm._t("default"),_c('Icon',{staticClass:"inline-alert-footer-link-icon",attrs:{"name":"external-link"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }